/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useMemo, useRef, useState, useEffect } from "react";
import { useDracoGLTF } from "../../../utils/useDracoGLTF";
import FactsAndFiguresMarker from "./FactsAndFiguresMarker";
import store from "../../../appStore";
import { useSnapshot } from "valtio";
import { degToRad } from "three/src/math/MathUtils";
import { config as springConfig, useTransition } from "@react-spring/three";
import Hotspot from "../../ui/Hotspot";
import { useTranslation } from "react-i18next";

export default function FactsAndFigures({ ...props }) {
  const group = useRef();
  const { nodes } = useDracoGLTF("./models/FactsAndFigures.glb");
  const snap = useSnapshot(store);
  const { t } = useTranslation();

  // const salesAndOfficesPositions = useMemo(() => {
  //   var positions = [];
  //   nodes["sales_offices"].children.forEach((c) => {
  //     positions.push(c.position);
  //   });
  //   return positions;
  // }, [nodes]);

  const manufacturingPositions = useMemo(() => {
    var positions = [];
    nodes["manufacturing"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const salesAndServicePositions = useMemo(() => {
    var positions = [];
    nodes["sales_service"].children.forEach((c) => {
      positions.push(c.position);
    });
    return positions;
  }, [nodes]);

  const [salesAndServiceState, setSalesAndServiceState] = useState([]);

  const SalesAndServiceTransition = useTransition(salesAndServiceState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const salesAndService = SalesAndServiceTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Sales_And_Service_${i}`}
        key={`Sales_And_Service_${i}`}
        rotation={[degToRad(-55.964), 0, 0]}
        color="#3F97B5"
        size={0.07}
        lineHeight={2}
      />
    );
  });

  const [manufacturingState, setManufacturingState] = useState([]);

  const ManufacturingTransition = useTransition(manufacturingState, {
    from: { scale: 0 },
    enter: { scale: 1 },
    leave: { scale: 0 },
    trail: 150,
    config: springConfig.default,
  });

  const manufacturing = ManufacturingTransition((style, item, t, i) => {
    return (
      <FactsAndFiguresMarker
        style={style}
        position={item}
        id={`Manufacturing_${i}`}
        key={`Manufacturing_${i}`}
        rotation={[degToRad(-55.964), 0, 0]}
        color="#F2C14E"
        circleSegments={4}
        size={0.07}
        lineHeight={2}
      />
    );
  });

  // const [saleAndOfficesState, setSaleAndOfficesState] = useState([]);

  // const SaleAndOfficesTransition = useTransition(saleAndOfficesState, {
  //   from: { scale: 0 },
  //   enter: { scale: 1 },
  //   leave: { scale: 0 },
  //   trail: 150,
  //   config: springConfig.default,
  // });

  // const saleAndOffices = SaleAndOfficesTransition((style, item, t, i) => {
  //   return (
  //     <FactsAndFiguresMarker
  //       style={style}
  //       position={item}
  //       id={`Sale_And_Offices_${i}`}
  //       key={`Sale_And_Offices_${i}`}
  //       rotation={[degToRad(-55.964), 0, 0]}
  //       circleSegments={16}
  //       color="#F2C14E"
  //       size={0.07}
  //       lineHeight={2}
  //     />
  //   );
  // });

  useEffect(() => {
    if (snap.locations.includes("sales_service")) {
      setSalesAndServiceState(salesAndServicePositions);
    } else {
      setSalesAndServiceState([]);
    }

    if (snap.locations.includes("manufacturing")) {
      setManufacturingState(manufacturingPositions);
    } else {
      setManufacturingState([]);
    }

    // if (snap.locations.includes("sales_offices")) {
    //   setSaleAndOfficesState(salesAndOfficesPositions);
    // } else {
    //   setSaleAndOfficesState([]);
    // }
  }, [snap.locations]);

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        position={nodes["FactsAndFigures"].position}
        //rotation={nodes["FactsAndFigures"].rotation}
      >
        {salesAndService}
        {manufacturing}
        {/* {saleAndOffices} */}
        <Hotspot
          position={[0, 0, -2.3]}
          text={t("L2_FACTS_AND_FIGURES_CONTACT_NAME")}
          onClick={() => openInNewTab(t("BUTTON_GET_IN_TOUCH_URL"))}
        />
      </group>
    </group>
  );
}

useDracoGLTF.preload("./models/FactsAndFigures.glb");
